<div class="form-container dark">
  <div class="w-full"></div>
  <div class="form-wrapper py-4">
    <form [formGroup]="editForm">
      <mat-form-field appearance="fill" style="width: 5rem">
        <mat-label>Tooth</mat-label>
        <input
          #tooth_field
          matInput
          formControlName="tooth"
          autocomplete="off"
        />
      </mat-form-field>

      <mat-form-field appearance="fill" style="width: 7rem">
        <mat-label>Severity</mat-label>
        <mat-select disabled formControlName="severity">
          <mat-option
            *ngFor="let severity of severityOptions"
            [value]="severity"
          >
            {{ severity }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- <mat-form-field appearance="outline" style="width: 5rem">
        <mat-label>Grade</mat-label>
        <input
          #grade
          matInput
          formControlName="grade"
          autocomplete="off"
        />
      </mat-form-field> -->

      <div class="error-container" *ngIf="editFormTooth?.errors">
        <span *ngIf="editFormTooth?.dirty && editFormTooth?.errors?.required">
          <i class="fa fas fa-info-circle"></i> Must specify a tooth.
        </span>

        <span *ngIf="editFormTooth?.errors?.requireSingleLetter">
          <i class="fa fas fa-info-circle"></i> This field must be within 1 -
          32.
        </span>

        <span *ngIf="editFormTooth?.errors?.invalidNumber">
          <i class="fa fas fa-info-circle"></i> Tooth number must be within 1 -
          32.
        </span>

        <span *ngIf="editFormTooth?.errors?.noLeadingZeroes">
          <i class="fa fas fa-info-circle"></i> Tooth number cannot be 0.
        </span>

        <span *ngIf="editFormTooth?.errors?.noNegativeValues">
          <i class="fa fas fa-info-circle"></i> Tooth value cannot be negative.
        </span>
      </div>
    </form>
  </div>
  <div class="edit-label-btns py-2">
    <button
      mat-flat-button
      class="save"
      color="primary"
      [ngClass]="{ disabled: !editForm.valid }"
      [disabled]="!editForm.valid || (isImageConfirmed$ | async)"
      (click)="onSaveClicked()"
    >
      Save
    </button>
    <button mat-stroked-button class="cancel" (click)="onCancelClicked()">
      Cancel
    </button>

    <button
      *ngIf="showDeletButton"
      mat-stroked-button
      class="delete"
      [disabled]="isImageConfirmed$ | async"
      (click)="onDeleteClicked()"
    >
      Delete
    </button>
  </div>
</div>
